webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularCookies = __webpack_require__(3);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularResource = __webpack_require__(5);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularSanitize = __webpack_require__(7);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _app = __webpack_require__(10);
	
	var _navbar = __webpack_require__(11);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _footer = __webpack_require__(13);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _main = __webpack_require__(15);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _app2 = __webpack_require__(18);
	
	var _app3 = _interopRequireDefault(_app2);
	
	var _util = __webpack_require__(20);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _angularSmartTable = __webpack_require__(22);
	
	var _angularSmartTable2 = _interopRequireDefault(_angularSmartTable);
	
	__webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('pba2050App', [_angularCookies2.default, _angularResource2.default, _angularSanitize2.default, _angularUiRouter2.default, _navbar2.default, _footer2.default, _main2.default, _angularSmartTable2.default, _app3.default, _util2.default]).config(_app.routeConfig);
	
	_angular2.default.element(document).ready(function () {
	  _angular2.default.bootstrap(document, ['pba2050App'], {
	    strictDi: true
	  });
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	routeConfig.$inject = ['$urlRouterProvider', '$locationProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routeConfig = routeConfig;
	function routeConfig($urlRouterProvider, $locationProvider) {
	  'ngInject';
	
	  $urlRouterProvider.otherwise('/');
	
	  $locationProvider.html5Mode({
	    enabled: true,
	    requireBase: false
	  });
	}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NavbarComponent = undefined;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavbarComponent = exports.NavbarComponent = function NavbarComponent() {
	  _classCallCheck(this, NavbarComponent);
	
	  this.menu = [{
	    title: 'Home',
	    state: 'main'
	  }];
	  this.isCollapsed = true;
	};
	
	exports.default = _angular2.default.module('directives.navbar', []).component('navbar', {
	  template: __webpack_require__(12),
	  controller: NavbarComponent
	}).name;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"navbar navbar-default navbar-static-top\">\n  <div class=\"container\">\n    <div class=\"navbar-header\">\n      <button class=\"navbar-toggle\" type=\"button\" ng-click=\"$ctrl.isCollapsed = !$ctrl.isCollapsed\">\n        <span class=\"sr-only\">Toggle navigation</span>\n        <span class=\"icon-bar\"></span>\n        <span class=\"icon-bar\"></span>\n        <span class=\"icon-bar\"></span>\n      </button>\n      <a href=\"/\" class=\"navbar-brand\">pba2050</a>\n    </div>\n    <div uib-collapse=\"$ctrl.isCollapsed\" class=\"navbar-collapse collapse\" id=\"navbar-main\">\n      <ul class=\"nav navbar-nav\">\n        <li ng-repeat=\"item in $ctrl.menu\" ui-sref-active=\"active\">\n            <a ui-sref=\"{{item.state}}\">{{item.title}}</a>\n        </li>\n      </ul>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FooterComponent = undefined;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FooterComponent = exports.FooterComponent = function FooterComponent() {
	  _classCallCheck(this, FooterComponent);
	};
	
	exports.default = _angular2.default.module('directives.footer', []).component('footer', {
	  template: __webpack_require__(14),
	  controller: FooterComponent
	}).name;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <p>Angular Fullstack v4.2.2 |\n    <a href=\"http://angular-fullstack.github.io/\">Documentation</a> |\n    <a href=\"https://gitter.im/DaftMonk/generator-angular-fullstack\">Chat on Gitter</a> |\n    <a href=\"https://github.com/angular-fullstack/generator-angular-fullstack/issues?state=open\">Issues</a> |\n    <a href=\"https://opencollective.com/angular-fullstack\">Donate to our Open Collective</a>\n  </p>\n</div>\n"

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MainController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _main = __webpack_require__(16);
	
	var _main2 = _interopRequireDefault(_main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MainController = exports.MainController = function () {
	
	  /*@ngInject*/
	  MainController.$inject = ['$http', '$scope'];
	  function MainController($http, $scope) {
	    _classCallCheck(this, MainController);
	
	    this.awesomeThings = [];
	
	    this.$http = $http;
	    this.$scope = $scope;
	  }
	
	  _createClass(MainController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$http.get('https://data.bayareametro.gov/resource/kgpp-qf8p.json').then(function (response) {
	        _this.$scope.rowCollection = response.data;
	        console.log(_this.$scope.rowCollection);
	      }).catch(function (err) {
	        console.log(err);
	      });
	
	      this.$http.get('https://data.bayareametro.gov/resource/kgpp-qf8p.json?$select=blueprint_strategy&$group=blueprint_strategy&$order=blueprint_strategy').then(function (response) {
	        _this.$scope.bpStrategies = response.data;
	        console.log(_this.$scope.bpStrategies);
	      }).catch(function (err) {
	        console.log(err);
	      });
	
	      this.$http.get('https://data.bayareametro.gov/resource/kgpp-qf8p.json?$select=open_period1&$group=open_period1&$order=open_period1').then(function (response) {
	        _this.$scope.openPeriods = response.data;
	        console.log(_this.$scope.openPeriods);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }]);
	
	  return MainController;
	}();
	
	exports.default = _angular2.default.module('pba2050App.main', [_angularUiRouter2.default]).config(_main2.default).component('main', {
	  template: __webpack_require__(17),
	  controller: MainController
	}).directive("stResetSearch", function () {
	  return {
	    restrict: 'EA',
	    require: '^stTable',
	    link: function link(scope, element, attrs, ctrl) {
	      return element.bind('click', function () {
	        return scope.$apply(function () {
	          var tableState;
	          tableState = ctrl.tableState();
	          tableState.search.predicateObject = {};
	          tableState.pagination.start = 0;
	          return ctrl.pipe();
	        });
	      });
	    }
	  };
	}).directive("stFilteredCollection", function () {
	  return {
	    require: "^stTable",
	    link: function link(scope, element, attr, ctrl) {
	      scope.$watch(ctrl.getFilteredCollection, function (val) {
	        scope.filteredCollection = val;
	      });
	    }
	  };
	}).directive('pageSelect', function () {
	  return {
	    restrict: 'E',
	    template: '<input type="text" class="select-page" ng-model="inputPage" ng-change="selectPage(inputPage)">',
	    link: function link(scope, element, attrs) {
	      scope.$watch('currentPage', function (c) {
	        scope.inputPage = c;
	      });
	    }
	  };
	}).name;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('main', {
	    url: '/',
	    template: '<main></main>'
	  });
	}

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\" style=\"padding-left:15%;padding-right:15%;\" st-table=\"displayedCollection\" st-safe-src=\"rowCollection\" st-filtered-collection>\n  <div class=\"row\" style=\"padding-top: 25px;padding-bottom: 10px;\">\n    <div class=\"col\">\n      <h2 style=\"text-align: center;\">Plan Bay Area 2050 Transportation Project List</h2>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-2\">\n      <div id=\"filtersTabPanel\">\n        <div class=\"tabFilters\">\n          <div class=\"tabFilterItems\">\n            <div>\n              <div class=\"row mt-2\">\n                <h4>Filter/Search <a href=\"/sources\">\n                  <i class=\"pl-1 fa fa-info-circle\" data-toggle=\"tooltip\" data-placement=\"top\"\n                    title=\"Use the options below to search or filter the project list. The search box searches against all fields in the table.\"></i>\n                </a>\n              </h4>\n                <div class=\"form-group\" style=\"padding-top:15px;padding-right:40px;\">\n                    <input st-search=\"\" placeholder=\"General Search...\" class=\"form-control\" type=\"search\" />\n               </div>\n              </div>\n              <div class=\"row mt-2\">\n                <!-- Blue Print Strategy  -->\n                <div class=\"form-group\" style=\"padding-top:15px;\">\n                  <label for=\"filter_blueprint_strategy\"><span style=\"font-weight: 400;\">Plan Strategy</span></label>\n                  <select class=\"form-select\" id=\"bluePrintStrategyControl\"\n                    ng-model=\"blueprint_strategy\" st-input-event=\"change\" st-search=\"blueprint_strategy\">\n                    <option ng-repeat=\"option in bpStrategies\" value=\"{{option.blueprint_strategy}}\">\n                      {{option.blueprint_strategy}} </option>\n                  </select>\n                </div>\n\n                <!-- Open Period  -->\n                <div class=\"form-group\" style=\"padding-top:15px;\">\n                  <label for=\"filter_blueprint_strategy\"><span style=\"font-weight: 400;\">Open Period</span></label>\n                  <select class=\"form-select\" id=\"openPeriodControl\"\n                    ng-model=\"blueprint_strategy\" st-input-event=\"change\" st-search=\"open_period1\">\n                    <option ng-repeat=\"option in openPeriods\" value=\"{{option.open_period1}}\">\n                      {{option.open_period1}} </option>\n                  </select>\n                </div>\n              \n                <!-- Update table/ Clear filters  -->\n                <div>\n                  <div style=\"padding-top:20px\">\n                    <div class=\"row\">\n                     <div class=\"col-md-12\">\n                       <button class=\"btn btn-primary\" st-reset-search><i class=\"fa fa-ban\"></i> Clear Filters</button>\n                    </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\n\n        </div>\n      </div>\n\n    </div>\n    <div class=\"col\" ng-show=\"rowCollection.length > 0\">\n      <div class=\"table-responsive\">\n        <table class=\"table\">\n          <thead>\n            <tr>\n              <th style=\"width:15%\">RTP ID</th>\n              <th style=\"width:30%\">Title</th>\n              <th style=\"width:35%\">Scope</th>\n              <th style=\"width:10%\">Open Period  <i class=\"pl-1 fa fa-info-circle\" data-toggle=\"tooltip\" data-placement=\"top\"\n                title=\"Open period denotes when the project is anticipated to open for use. Various indicates the program is anticipated to have project opening dates in both plan periods.\"></i></th>\n              <th style=\"text-align: right; width:10%\">Funding (millions of YOE$)*</th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"row in displayedCollection\">\n              <td>{{row.rtpid}}</td>\n              <td>{{row.title}}</td>\n              <td>{{row.scope}}</td>\n              <td>{{row.open_period1}}</td>\n              <td style=\"text-align: right;\">${{row.cost_funding2_millions_yoe | number : 0}}</td>\n            </tr>\n          </tbody>\n        </table>\n        <div class=\"row\">\n          <div class=\"col-md-6\">\n            <div st-items-by-page=\"5\" st-pagination=\"\" st-displayed-pages=\"7\"\n              st-template=\"../assets/html/templates/pageSelect.txt\">\n              <pagination></pagination>\n            </div>\n            \n          </div>\n          <div class=\"col-md-6\">\n            <div style=\"float:right;\">\n              <a href=\"https://data.bayareametro.gov/dataset/Plan-Bay-Area-2050-Project-List-Draft-1-/reyk-etjd\" target=\"_blank\" class=\"btn btn-primary\" ng-show=\"rowCollection.length > 0\">Download Data</a>\n              <span style=\"padding-right:10px;margin:0;font-weight: bold;\">Total Records: {{filteredCollection.length}}</span>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col\">\n           <span style=\"font-size: small;padding-top:10px;\">* Funding is reported in year-of-expenditure (YOE) dollars, accounting for an annual inflation rate of 2.2%. Funding accounts for both capital and operations and maintenance costs.</span>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n\n"

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('pba2050App.constants', []).constant('appConfig', __webpack_require__(19)).name;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';
	
	exports = module.exports = {
	  // List of user roles
	  userRoles: ['guest', 'user', 'admin']
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _util = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('pba2050App.util', []).factory('Util', _util.UtilService).name;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	UtilService.$inject = ['$window'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UtilService = UtilService;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UtilService($window) {
	  'ngInject';
	
	  var Util = {
	    safeCb: function safeCb(cb) {
	      return _angular2.default.isFunction(cb) ? cb : _angular2.default.noop;
	    },
	    urlParse: function urlParse(url) {
	      var a = document.createElement('a');
	      a.href = url;
	
	      if (a.host === '') {
	        a.href = a.href;
	      }
	
	      return a;
	    },
	    isSameOrigin: function isSameOrigin(url, origins) {
	      url = Util.urlParse(url);
	      origins = origins && [].concat(origins) || [];
	      origins = origins.map(Util.urlParse);
	      origins.push($window.location);
	      origins = origins.filter(function (o) {
	        var hostnameCheck = url.hostname === o.hostname;
	        var protocolCheck = url.protocol === o.protocol;
	
	        var portCheck = url.port === o.port || o.port === '' && (url.port === '80' || url.port === '443');
	        return hostnameCheck && protocolCheck && portCheck;
	      });
	      return origins.length >= 1;
	    }
	  };
	
	  return Util;
	}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(23);
	module.exports = 'smart-table';

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	(function (ng, undefined) {
	  'use strict';
	
	  ng.module('smart-table', []).run(['$templateCache', function ($templateCache) {
	    $templateCache.put('template/smart-table/pagination.html', '<nav ng-if="numPages && pages.length >= 2"><ul class="pagination">' + '<li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="#" ng-click="selectPage(page); $event.preventDefault(); $event.stopPropagation();">{{page}}</a></li>' + '</ul></nav>');
	  }]);
	
	  ng.module('smart-table').constant('stConfig', {
	    pagination: {
	      template: 'template/smart-table/pagination.html',
	      itemsByPage: 10,
	      displayedPages: 5
	    },
	    search: {
	      delay: 400,
	      inputEvent: 'input',
	      trimSearch: false
	    },
	    select: {
	      mode: 'single',
	      selectedClass: 'st-selected'
	    },
	    sort: {
	      ascentClass: 'st-sort-ascent',
	      descentClass: 'st-sort-descent',
	      descendingFirst: false,
	      skipNatural: false,
	      delay: 300
	    },
	    pipe: {
	      delay: 100 }
	  });
	  ng.module('smart-table').controller('stTableController', ['$scope', '$parse', '$filter', '$attrs', function StTableController($scope, $parse, $filter, $attrs) {
	    var propertyName = $attrs.stTable;
	    var displayGetter = $parse(propertyName);
	    var displaySetter = displayGetter.assign;
	    var safeGetter;
	    var orderBy = $filter('orderBy');
	    var filter = $filter('filter');
	    var safeCopy = copyRefs(displayGetter($scope));
	    var tableState = {
	      sort: {},
	      search: {},
	      pagination: { start: 0, totalItemCount: 0 }
	    };
	    var filtered;
	    var pipeAfterSafeCopy = true;
	    var ctrl = this;
	    var lastSelected;
	
	    function copyRefs(src) {
	      return src ? [].concat(src) : [];
	    }
	
	    function updateSafeCopy() {
	      safeCopy = copyRefs(safeGetter($scope));
	      if (pipeAfterSafeCopy === true) {
	        ctrl.pipe();
	      }
	    }
	
	    function deepDelete(object, path) {
	      if (path.indexOf('.') != -1) {
	        var partials = path.split('.');
	        var key = partials.pop();
	        var parentPath = partials.join('.');
	        var parentObject = $parse(parentPath)(object);
	        delete parentObject[key];
	        if (Object.keys(parentObject).length == 0) {
	          deepDelete(object, parentPath);
	        }
	      } else {
	        delete object[path];
	      }
	    }
	
	    if ($attrs.stSafeSrc) {
	      safeGetter = $parse($attrs.stSafeSrc);
	      $scope.$watch(function () {
	        var safeSrc = safeGetter($scope);
	        return safeSrc && safeSrc.length ? safeSrc[0] : undefined;
	      }, function (newValue, oldValue) {
	        if (newValue !== oldValue) {
	          updateSafeCopy();
	        }
	      });
	      $scope.$watch(function () {
	        var safeSrc = safeGetter($scope);
	        return safeSrc ? safeSrc.length : 0;
	      }, function (newValue, oldValue) {
	        if (newValue !== safeCopy.length) {
	          updateSafeCopy();
	        }
	      });
	      $scope.$watch(function () {
	        return safeGetter($scope);
	      }, function (newValue, oldValue) {
	        if (newValue !== oldValue) {
	          tableState.pagination.start = 0;
	          updateSafeCopy();
	        }
	      });
	    }
	
	    this.sortBy = function sortBy(predicate, reverse) {
	      tableState.sort.predicate = predicate;
	      tableState.sort.reverse = reverse === true;
	
	      if (ng.isFunction(predicate)) {
	        tableState.sort.functionName = predicate.name;
	      } else {
	        delete tableState.sort.functionName;
	      }
	
	      tableState.pagination.start = 0;
	      return this.pipe();
	    };
	
	    this.search = function search(input, predicate, comparator) {
	      var predicateObject = tableState.search.predicateObject || {};
	      var prop = predicate ? predicate : '$';
	
	      $parse(prop).assign(predicateObject, input);
	
	      if (!input) {
	        deepDelete(predicateObject, prop);
	      }
	      tableState.search.predicateObject = predicateObject;
	      tableState.pagination.start = 0;
	      return this.pipe();
	    };
	
	    this.pipe = function pipe() {
	      var pagination = tableState.pagination;
	      var output;
	      filtered = tableState.search.predicateObject ? filter(safeCopy, tableState.search.predicateObject) : safeCopy;
	      if (tableState.sort.predicate) {
	        filtered = orderBy(filtered, tableState.sort.predicate, tableState.sort.reverse);
	      }
	      pagination.totalItemCount = filtered.length;
	      if (pagination.number !== undefined) {
	        pagination.numberOfPages = filtered.length > 0 ? Math.ceil(filtered.length / pagination.number) : 1;
	        pagination.start = pagination.start >= filtered.length ? (pagination.numberOfPages - 1) * pagination.number : pagination.start;
	        output = filtered.slice(pagination.start, pagination.start + parseInt(pagination.number));
	      }
	      displaySetter($scope, output || filtered);
	    };
	
	    this.select = function select(row, mode) {
	      var rows = copyRefs(displayGetter($scope));
	      var index = rows.indexOf(row);
	      if (index !== -1) {
	        if (mode === 'single') {
	          row.isSelected = row.isSelected !== true;
	          if (lastSelected) {
	            lastSelected.isSelected = false;
	          }
	          lastSelected = row.isSelected === true ? row : undefined;
	        } else {
	          rows[index].isSelected = !rows[index].isSelected;
	        }
	      }
	    };
	
	    this.slice = function splice(start, number) {
	      tableState.pagination.start = start;
	      tableState.pagination.number = number;
	      return this.pipe();
	    };
	
	    this.tableState = function getTableState() {
	      return tableState;
	    };
	
	    this.getFilteredCollection = function getFilteredCollection() {
	      return filtered || safeCopy;
	    };
	
	    this.setFilterFunction = function setFilterFunction(filterName) {
	      filter = $filter(filterName);
	    };
	
	    this.setSortFunction = function setSortFunction(sortFunctionName) {
	      orderBy = $filter(sortFunctionName);
	    };
	
	    this.preventPipeOnWatch = function preventPipe() {
	      pipeAfterSafeCopy = false;
	    };
	  }]).directive('stTable', function () {
	    return {
	      restrict: 'A',
	      controller: 'stTableController',
	      link: function link(scope, element, attr, ctrl) {
	        if (attr.stSetFilter) {
	          ctrl.setFilterFunction(attr.stSetFilter);
	        }
	
	        if (attr.stSetSort) {
	          ctrl.setSortFunction(attr.stSetSort);
	        }
	      }
	    };
	  });
	
	  ng.module('smart-table').directive('stSearch', ['stConfig', '$timeout', '$parse', function (stConfig, $timeout, $parse) {
	    return {
	      require: '^stTable',
	      link: function link(scope, element, attr, ctrl) {
	        var tableCtrl = ctrl;
	        var promise = null;
	        var throttle = attr.stDelay || stConfig.search.delay;
	        var event = attr.stInputEvent || stConfig.search.inputEvent;
	        var trimSearch = attr.trimSearch || stConfig.search.trimSearch;
	
	        attr.$observe('stSearch', function (newValue, oldValue) {
	          var input = element[0].value;
	          if (newValue !== oldValue && input) {
	            ctrl.tableState().search = {};
	            input = ng.isString(input) && trimSearch ? input.trim() : input;
	            tableCtrl.search(input, newValue);
	          }
	        });
	
	        scope.$watch(function () {
	          return ctrl.tableState().search;
	        }, function (newValue, oldValue) {
	          var predicateExpression = attr.stSearch || '$';
	          if (newValue.predicateObject && $parse(predicateExpression)(newValue.predicateObject) !== element[0].value) {
	            element[0].value = $parse(predicateExpression)(newValue.predicateObject) || '';
	          }
	        }, true);
	
	        element.bind(event, function (evt) {
	          evt = evt.originalEvent || evt;
	          if (promise !== null) {
	            $timeout.cancel(promise);
	          }
	
	          promise = $timeout(function () {
	            var input = evt.target.value;
	            input = ng.isString(input) && trimSearch ? input.trim() : input;
	            tableCtrl.search(input, attr.stSearch || '');
	            promise = null;
	          }, throttle);
	        });
	      }
	    };
	  }]);
	
	  ng.module('smart-table').directive('stSelectRow', ['stConfig', function (stConfig) {
	    return {
	      restrict: 'A',
	      require: '^stTable',
	      scope: {
	        row: '=stSelectRow'
	      },
	      link: function link(scope, element, attr, ctrl) {
	        var mode = attr.stSelectMode || stConfig.select.mode;
	        element.bind('click', function () {
	          scope.$apply(function () {
	            ctrl.select(scope.row, mode);
	          });
	        });
	
	        scope.$watch('row.isSelected', function (newValue) {
	          if (newValue === true) {
	            element.addClass(stConfig.select.selectedClass);
	          } else {
	            element.removeClass(stConfig.select.selectedClass);
	          }
	        });
	      }
	    };
	  }]);
	
	  ng.module('smart-table').directive('stSort', ['stConfig', '$parse', '$timeout', function (stConfig, $parse, $timeout) {
	    return {
	      restrict: 'A',
	      require: '^stTable',
	      link: function link(scope, element, attr, ctrl) {
	
	        var predicate = attr.stSort;
	        var getter = $parse(predicate);
	        var index = 0;
	        var classAscent = attr.stClassAscent || stConfig.sort.ascentClass;
	        var classDescent = attr.stClassDescent || stConfig.sort.descentClass;
	        var stateClasses = [classAscent, classDescent];
	        var sortDefault;
	        var skipNatural = attr.stSkipNatural !== undefined ? attr.stSkipNatural : stConfig.sort.skipNatural;
	        var descendingFirst = attr.stDescendingFirst !== undefined ? attr.stDescendingFirst : stConfig.sort.descendingFirst;
	        var promise = null;
	        var throttle = attr.stDelay || stConfig.sort.delay;
	
	        var ariaSort = 'aria-sort';
	        var ariaSortNone = 'none';
	        var ariaSortAscending = 'ascending';
	        var ariaSortDescending = 'descending';
	        element.attr('role', 'columnheader').attr(ariaSort, ariaSortNone);
	
	        if (attr.stSortDefault) {
	          sortDefault = scope.$eval(attr.stSortDefault) !== undefined ? scope.$eval(attr.stSortDefault) : attr.stSortDefault;
	        }
	
	        function sort() {
	          if (descendingFirst) {
	            index = index === 0 ? 2 : index - 1;
	          } else {
	            index++;
	          }
	
	          var func;
	          predicate = ng.isFunction(getter(scope)) || ng.isArray(getter(scope)) ? getter(scope) : attr.stSort;
	          if (index % 3 === 0 && !!skipNatural !== true) {
	            index = 0;
	            ctrl.tableState().sort = {};
	            ctrl.tableState().pagination.start = 0;
	            func = ctrl.pipe.bind(ctrl);
	          } else {
	            func = ctrl.sortBy.bind(ctrl, predicate, index % 2 === 0);
	          }
	          if (promise !== null) {
	            $timeout.cancel(promise);
	          }
	          if (throttle < 0) {
	            func();
	          } else {
	            promise = $timeout(function () {
	              func();
	            }, throttle);
	          }
	        }
	
	        element.bind('click', function sortClick() {
	          if (predicate) {
	            scope.$apply(sort);
	          }
	        });
	
	        if (sortDefault) {
	          index = sortDefault === 'reverse' ? 1 : 0;
	          sort();
	        }
	
	        scope.$watch(function () {
	          return ctrl.tableState().sort;
	        }, function (newValue) {
	          if (newValue.predicate !== predicate) {
	            index = 0;
	            element.removeClass(classAscent).removeClass(classDescent).attr(ariaSort, ariaSortNone);
	          } else {
	            index = newValue.reverse === true ? 2 : 1;
	            element.removeClass(stateClasses[index % 2]).addClass(stateClasses[index - 1]).attr(ariaSort, newValue.reverse ? ariaSortAscending : ariaSortDescending);
	          }
	        }, true);
	      }
	    };
	  }]);
	
	  ng.module('smart-table').directive('stPagination', ['stConfig', function (stConfig) {
	    return {
	      restrict: 'EA',
	      require: '^stTable',
	      scope: {
	        stItemsByPage: '=?',
	        stDisplayedPages: '=?',
	        stPageChange: '&'
	      },
	      templateUrl: function templateUrl(element, attrs) {
	        if (attrs.stTemplate) {
	          return attrs.stTemplate;
	        }
	        return stConfig.pagination.template;
	      },
	      link: function link(scope, element, attrs, ctrl) {
	
	        scope.stItemsByPage = scope.stItemsByPage ? +scope.stItemsByPage : stConfig.pagination.itemsByPage;
	        scope.stDisplayedPages = scope.stDisplayedPages ? +scope.stDisplayedPages : stConfig.pagination.displayedPages;
	
	        scope.currentPage = 1;
	        scope.pages = [];
	
	        function redraw() {
	          var paginationState = ctrl.tableState().pagination;
	          var start = 1;
	          var end;
	          var i;
	          var prevPage = scope.currentPage;
	          scope.totalItemCount = paginationState.totalItemCount;
	          scope.currentPage = Math.floor(paginationState.start / paginationState.number) + 1;
	
	          start = Math.max(start, scope.currentPage - Math.abs(Math.floor(scope.stDisplayedPages / 2)));
	          end = start + scope.stDisplayedPages;
	
	          if (end > paginationState.numberOfPages) {
	            end = paginationState.numberOfPages + 1;
	            start = Math.max(1, end - scope.stDisplayedPages);
	          }
	
	          scope.pages = [];
	          scope.numPages = paginationState.numberOfPages;
	
	          for (i = start; i < end; i++) {
	            scope.pages.push(i);
	          }
	
	          if (prevPage !== scope.currentPage) {
	            scope.stPageChange({ newPage: scope.currentPage });
	          }
	        }
	
	        scope.$watch(function () {
	          return ctrl.tableState().pagination;
	        }, redraw, true);
	
	        scope.$watch('stItemsByPage', function (newValue, oldValue) {
	          if (newValue !== oldValue) {
	            scope.selectPage(1);
	          }
	        });
	
	        scope.$watch('stDisplayedPages', redraw);
	
	        scope.selectPage = function (page) {
	          if (page > 0 && page <= scope.numPages) {
	            ctrl.slice((page - 1) * scope.stItemsByPage, scope.stItemsByPage);
	          }
	        };
	
	        if (!ctrl.tableState().pagination.number) {
	          ctrl.slice(0, scope.stItemsByPage);
	        }
	      }
	    };
	  }]);
	
	  ng.module('smart-table').directive('stPipe', ['stConfig', '$timeout', function (config, $timeout) {
	    return {
	      require: 'stTable',
	      scope: {
	        stPipe: '='
	      },
	      link: {
	
	        pre: function pre(scope, element, attrs, ctrl) {
	
	          var pipePromise = null;
	
	          if (ng.isFunction(scope.stPipe)) {
	            ctrl.preventPipeOnWatch();
	            ctrl.pipe = function () {
	
	              if (pipePromise !== null) {
	                $timeout.cancel(pipePromise);
	              }
	
	              pipePromise = $timeout(function () {
	                scope.stPipe(ctrl.tableState(), ctrl);
	              }, config.pipe.delay);
	
	              return pipePromise;
	            };
	          }
	        },
	
	        post: function post(scope, element, attrs, ctrl) {
	          ctrl.pipe();
	        }
	      }
	    };
	  }]);
	})(angular);

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
]);


// WEBPACK FOOTER //
// app.e2c5b3ed034db889794a.js